import { z } from 'zod'

export const ticketsetSchema = z.object({
    name: z.string().min(1, 'Povinné pole').max(128, 'Maximálně 128 znaků'),
    customName: z.string().max(255, 'Maximálně 255 znaků').nullable(),
    validate: z.boolean()
})

export type TicketsetFormValues = z.infer<typeof ticketsetSchema>
